export default __webpack_public_path__ + "static/media/share.8470d1e5.svg";